import { Injectable } from '@angular/core';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

@Injectable({
  providedIn: 'root',
})
export class PrintService {
  printContent(elementId: string, filename: string): void {
    const content = document.getElementById(elementId);
    const printButton = document.querySelector('.print-button') as HTMLElement;

    if (printButton) {
      printButton.style.display = 'none';
    }

    if (content) {
      html2canvas(content, { scale: 2 })
        .then((canvas) => {
          const pdf = new jsPDF('p', 'mm', 'a4');
          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const margin = 13;
          const pdfWidth = pageWidth - 2 * margin;
          const pdfHeight = pageHeight - 2 * margin;

          const canvasWidth = canvas.width;
          const canvasHeight = canvas.height;
          const imgHeightRatio = pdfWidth / canvasWidth;
          const imgHeight = canvasHeight * imgHeightRatio;
          const pageCanvasHeight = (pdfHeight / imgHeight) * canvasHeight;

          const pageCount = Math.ceil(canvasHeight / pageCanvasHeight);
          let position = 0;

          for (let i = 0; i < pageCount; i++) {
            const pageCanvas = document.createElement('canvas');
            pageCanvas.width = canvasWidth;
            pageCanvas.height = Math.min(
              pageCanvasHeight,
              canvasHeight - position
            );

            const ctx = pageCanvas.getContext('2d');
            if (ctx) {
              ctx.drawImage(
                canvas,
                0,
                position,
                canvasWidth,
                pageCanvas.height,
                0,
                0,
                canvasWidth,
                pageCanvas.height
              );
            }

            const pageImgData = pageCanvas.toDataURL('image/png');
            if (i > 0) pdf.addPage();
            pdf.addImage(
              pageImgData,
              'PNG',
              margin,
              margin,
              pdfWidth,
              (pageCanvas.height * pdfWidth) / canvasWidth
            );
            position += pageCanvasHeight;
          }

          pdf.save(`${filename}.pdf`);
        })
        .finally(() => {
          if (printButton) {
            printButton.style.display = '';
          }
        });
    }
  }
}
